import styled from "styled-components";
import React, { FC } from "react";
import dayjs from "dayjs";
import { theme } from "@ifgengineering/component-library";
import { ThemedText } from "@components/ThemedText";
import { V3Button } from "@components/v3/primitives";
import noLogoImage from "@assets/cur8/img/no-logo-deal.png";

const NotificationListItemStyled = styled.div`
  display: flex;
  padding: 20px;
  border-bottom-color: ${theme.colors.SLATE300};
  border-bottom-width: 1px;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 4px;
  align-items: center;
`;

const Body = styled.div`
  display: flex;
  margin-left: 34px;
  flex-direction: column;
  gap: 10px;
`;

const Logo = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 24px;
  background-color: ${theme.colors.WHITE};
  margin-right: 10px;
  border: 1px solid ${theme.colors.SLATE300};
`;

const Title = styled.div`
  display: flex;
`;

const Time = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  width: 200px;
  flex-grow: 1;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;

  & > button {
    white-space: nowrap;
  }
`;

type TProps = {
  icon?: string | null;
  sentAt: string;
  heading: string;
  description: string;
  ctaLabel?: string;
  onClick?: () => void;
};

const NotificationListItem: FC<TProps> = ({
  sentAt,
  description,
  heading,
  icon,
  ctaLabel,
  onClick,
}: TProps) => {
  const formattedSentAt = dayjs(sentAt).format("DD/MM hh:mm A");
  return (
    <NotificationListItemStyled>
      <Header>
        <Logo
          src={icon || noLogoImage}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = noLogoImage;
          }}
        />
        <Title>
          <ThemedText type="S14" color="SLATE900">
            {heading}
          </ThemedText>
        </Title>
      </Header>
      <Body>
        <ThemedText type="P14" color="SLATE800">
          {description}
        </ThemedText>
        <ButtonWrapper>
          {onClick && ctaLabel && (
            <V3Button
              testID="notification-cta"
              variant="outline"
              size="sm"
              onClick={onClick}
            >
              {ctaLabel}
            </V3Button>
          )}
          <Time>
            <ThemedText type="P12" color="SLATE600">
              {formattedSentAt}
            </ThemedText>
          </Time>
        </ButtonWrapper>
      </Body>
    </NotificationListItemStyled>
  );
};

export default NotificationListItem;
